import React from "react";
import { FormikProps } from "formik";
import { Button, Form, } from "semantic-ui-react";
import { ModalExt, Severity } from "@crispico/foundation-react/components/ModalExt/ModalExt";

interface InvoiceOpenFieldEditorProps {
    fieldName: string;
    formikProps: FormikProps<any>;
}

interface InvoiceOpenFieldEditorState {
    showModal: boolean;
    checked: boolean | undefined;
}

export class InvoiceOpenFieldEditor extends React.Component<InvoiceOpenFieldEditorProps, InvoiceOpenFieldEditorState> {
    constructor(props: InvoiceOpenFieldEditorProps) {
        super(props);
        this.state = {
            checked: false,
            showModal: false
        }
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    confirmClose() {
        this.props.formikProps.setFieldValue(this.props.fieldName, this.state.checked);
        this.closeModal();
    }

    render() {
        return <>
            <ModalExt size="tiny" severity={Severity.CONFIRMATION} open={this.state.showModal}
                content={_msg("InvoiceConfirmationCloseModal.message")} onClose={() => this.closeModal()}
                actions={[
                    <Button primary content={_msg("general.ok")} onClick={() => this.confirmClose()} />,
                    <Button primary content={_msg("general.cancel")} onClick={() => this.closeModal()} />
                ]}/>
            <Form.Checkbox checked={this.props.formikProps.values[this.props.fieldName]} disabled={!this.props.formikProps.values[this.props.fieldName]} onChange={((e, data) => this.setState({ checked: data.checked, showModal: true }))} />
        </>
    }
}